export default __webpack_public_path__ + "static/media/about-location-map-mobile.4c59dcb9.png";